import React, { ReactElement, ForwardedRef } from 'react';
import { Field } from 'react-final-form';
import FieldNumber from '../field-number/field-number.component';
import FormFieldContainer from '../form-field-container/form-field-container.component';
import FormatService from '../../services/format-service';

const FormFieldNumber: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const {
    name,
    isPercent,
    withNoLimit,
    onChange,
    ...custom
  } = props;

  const limit: number | undefined = isPercent && !withNoLimit ? FormatService.PERCENT_NUMBER_LIMIT : undefined;

  const parse: FormFieldParseFunction = (value: string): string => (
    limit && FormatService.parseFloat(value) > limit ? limit.toString() : value
  );

  return (
    <FormFieldContainer name={name} onChange={onChange}>
      <Field name={name} parse={parse}>
        {
          (fieldProps: ReactComponentProps): ReactElement => (
            <FieldNumber
              isPlain={false}
              isPercent={isPercent}
              withNoLimit={withNoLimit}
              ref={ref}
              name={name}
              onChange={onChange}
              {...fieldProps}
              {...custom}
            />
          )
        }
      </Field>
    </FormFieldContainer>
  );
}));

export default FormFieldNumber;
